import { useState, useEffect } from 'react';
import {
  Dropdown,
  DropdownItem,
  DropdownToggle,
  DropdownMenu,
  Input,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  Form,
  FormGroup
} from 'reactstrap';
import message from "../../../assets/images/message.png";
import { Box } from '@mui/material';
import close from "../../../assets/images/close.png";
import action3 from "../../../assets/images/action3.png";
import { userActions } from '../../../actions/user.actions';
import 'react-bootstrap-switch/dist/css/bootstrap3/react-bootstrap-switch.min.css';
import { useSelector, useDispatch } from "react-redux";
import * as moment from 'moment';
import axiosInstance from '../../../helpers/axios';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import OtpConsent from '../../Consent/OtpConsent/OtpConsent';
import CircularProgress from '@mui/material/CircularProgress';
import Datetime from 'react-datetime';
import { ApplicationStatusEnum, states } from '../../../data';
import { useCurrentUser } from '../../../hooks/useCurrentUser';
export default function MoveProcessingStatus(ApplicantId) {
  const doReload = ApplicantId.onSuccess ?? (() => window.location.reload());
  //to refresh token

  const decode = useCurrentUser();
  const user = null;

  const rejectionReasons = [
    { label: "Credit Score", value: 1 },
    { label: "Low Income", value: 2 },
    { label: "FOIR", value: 3 },
    { label: "Document Issue", value: 4 },
    { label: "Bank Analysis Fail", value: 5 },
    { label: "Policy Breach", value: 6 },
    { label: "Fraud Flag", value: 7 },
    { label: "Other", value: 8 },
  ];
  const subRejectionReasons = [
    { label: "Wrong State", value: 1 },
    { label: "Self-Employed", value: 2 },
    { label: "Age Below Minimum", value: 3 },
    { label: "Low Salary", value: 4 },
    { label: "Repeat Application", value: 5 },
    { label: "Other Policy", value: 6 },
  ];
  const bankAnalysisSubReasons = [
    { label: "Low / Insufficient Salary Credits", value: 7 },
    { label: "Bounced EMIs / Cheque Returns", value: 8 },
    { label: "High Obligations (FOIR)", value: 9 },
    { label: "Salary Not Credited / Irregular", value: 10 },
    { label: "Statement Unreadable / Parse Fail", value: 11 },
    { label: "Suspected Tampered Statement", value: 12 },
    { label: "Insufficient Transaction History", value: 13 },
    { label: "Other (Bank Analysis)", value: 14 },
  ];

  const updateDroppedStatus = `/admin/application/update-status`;

  const urlApproveApiProd = `/products/instituteId?instituteId=${ApplicantId.ApplicantId.instituteId}`;
  const urlApproveApiFund = `/fund_source/for-institute?instituteId=${ApplicantId.ApplicantId.instituteId}`;
  const [isApiError, setIsApiError] = useState(false);
  const [formStatusOpen, setStatusOpen] = useState(false);
  const [dropDownOpen, setDropDownOpen] = useState(false);
  const [fundDropDownOpen, setFundDropDownOpen] = useState(false);
  const [descriptionText, setDescriptionText] = useState('');
  const [status, setStatus] = useState('Select Status');
  const [rejectionReason, setRejectionReason] = useState("");
  const [subRejectionReason, setSubRejectionReason] = useState("");
  const [prodArray, setProdArray] = useState([]);
  const [fundSourceName, setFundSourceName] = useState('Fund Source');
  const [fundSourceArray, setFundSourceArray] = useState([]);
  const [form, setForm] = useState(prodArray ? prodArray : null);
  const [formLoader, setFormLoader] = useState(false);
  const [coAppNumber, setCoAppNumber] = useState(false);
  const [coAppFName, setCoAppFName] = useState('');
  const [dateEmi, setEmiDate] = useState(null);
  const [dayEmi, setEmiDay] = useState(null);
  const [approvalType, setApprovalType] = useState('Select Approval Type');
  const [approvalTypeValue, setApprovalTypeValue] = useState(null);
  const [approvalTypeDropdownOpen, setApprovalTypeDropdownOpen] = useState(false);
  const [remarks, setRemarks] = useState('');
  const [coAppEmail, setCoAppEmail] = useState('');
  const [relationshipStatus, setRelationshipStatus] = useState('Select Relation with Applicant');
  const [relationshipStatusDropdown, setRelationshipStatusDropdown] = useState(false);
  const [confirmationDialog, setConfirmationDialog] = useState(false);
  const [confirmationMessage, setConfirmationMessage] = useState('Hold On...');
  const [coAppAadhaar, setCoAppAadhaar] = useState(false);
  const [coAppAddress, setCoAppAddress] = useState(null);
  const [coAppDob, setCoAppDob] = useState(null);
  const [coAppCity, setCoAppCity] = useState("");
  const [coAppState, setCoAppState] = useState("");
  const [coAppPincode, setCoAppPincode] = useState("");
  const [coAppPAN, setCoAppPAN] = useState(false);
  const [aadhaarBackUpload, setAadhaarBackUpload] = useState(null);
  const [aadhaarFrontUpload, setAadhaarFrontUpload] = useState(null);
  const [panUpload, setPanUpload] = useState(null);
  const [alertMessage,setAlertMessage]=useState(null)
  const [runBothEmandate,setRunBothEmandateCheck]=useState(false)
  const [runEmandate,setRunEmandateCheck]=useState(false)
  const [mandateCheckOpen,setMandateCheckOpen]=useState(false)
  const [bothMandateCheckOpen,setBothMandateCheckOpen]=useState(false)
  const [flagForMainApplicant,setFlagForMainApplicant]=useState(false)
  const [isLoading, setIsLoading] = useState(false);
  const [openOtpConsent, setOpenOtpConsent] = useState(false);
   const [aadhaarImage1Url, setAadhaarImage1Url] = useState('');
  const [aadhaarImage2Url, setAadhaarImage2Url] = useState('');
  const [panImageUrl, setPanImageUrl] = useState('');
  const dispatch = useDispatch()
  const droppedstate = useSelector((state) => state.Droppedstatuschange?.res)
  const ruleStatus = ApplicantId.ApplicantId.ruleStatus

  const [ocrFormData,setOCRFormData]=useState(null);
const[ocrReadDone,setOCRReadDone]=useState(false)


const [ocrAadhaarFront,setOCRAadhaarFront]=useState(null)
const [ocrAadhaarBack,setOCRAadhaarBack]=useState(null)
const [ocrPan,setOCRPan]=useState(null)

  const [employment, setEmployment] = useState(null)
  const [employerName, setEmployerName] = useState(null)
  const [income, setIncome] = useState(null)

const readOcr=()=>{
  setIsLoading(true)
  const readOCRUrl=`/ocr/read`
  const data=new FormData();

 if(ocrAadhaarFront)
    data.append("aadhaarFront",ocrAadhaarFront);
  if(ocrAadhaarBack)
    data.append("aadhaarBack",ocrAadhaarBack);
  if(ocrPan)
    data.append("pan",ocrPan);

  axiosInstance.post(readOCRUrl,data)
  .then((res=>{
    
    axiosInstance.get(`/ocr/data?id=${res.data.data.id}`)
    .then(async (resp) => {
  setOCRReadDone(!ocrReadDone);
  setOCRFormData(resp.data.data);

  const [aadhaar1Url, aadhaar2Url, panUrl] = await Promise.all([
    handleViewFile(resp?.data?.data?.aadhaarImage1),
    handleViewFile(resp?.data?.data?.aadhaarImage2),
    handleViewFile(resp?.data?.data?.panImage),
  ]);

  setAadhaarImage1Url(aadhaar1Url);
  setAadhaarImage2Url(aadhaar2Url);
  setPanImageUrl(panUrl);
  setIsLoading(false);
})

    .catch((err)=>alert("Fail to read OCR details"))
  }))
  .catch((err)=>alert("OCR read Failed!"));
}


const extractPath = (s3Url) => {
  const keywords = ['aadhaar_front', 'aadhaar_back', 'pan'];
  for (const keyword of keywords) {
    const index = s3Url?.indexOf(keyword);
    if (index !== -1) {
      return s3Url.substring(index);
    }
  }
  return '';
};

 const handleViewFile = async (s3Url) => {
  try {

    const extractedString = extractPath(s3Url);

    const url = `/file/url-content?path=${extractedString}`;
    const res = await axiosInstance.get(url, {
      headers: {
      },
    });
    return res?.data?.data || '';
  } catch (e) {
    console.error(e);
  }
};

const previewOcrAadhaarFront=(e)=>{
  setOCRAadhaarFront(e.target.files[0])
  const output = document.getElementById('ocrAadhaarFOutput');
    output.src = URL.createObjectURL(e.target.files[0]);
    output.onload = function() {
      URL.revokeObjectURL(output.src) // free memory
    }
  }
const previewOcrAadhaarBack=(e)=>{
  setOCRAadhaarBack(e.target.files[0])
  const output = document.getElementById('ocrAadhaarBOutput');
    output.src = URL.createObjectURL(e.target.files[0]);
    output.onload = function() {
      URL.revokeObjectURL(output.src) // free memory
    }
  }
const previewOcrPan=(e)=>{
  setOCRPan(e.target.files[0])
  const output = document.getElementById('ocrPanOutput');
    output.src = URL.createObjectURL(e.target.files[0]);
    output.onload = function() {
      URL.revokeObjectURL(output.src) // free memory
    }
  }
const handleMainApplicantSelectApplicant=()=>{
  document.getElementById("applicantCheck").checked=true
  document.getElementById("coapplicantCheck").checked=false
  setFlagForMainApplicant(document.getElementById("coapplicantCheck").checked)
  

    
}
const handleMainApplicantSelectCoApplicant=()=>{
   document.getElementById("applicantCheck").checked=false
  document.getElementById("coapplicantCheck").checked=true
  setFlagForMainApplicant(document.getElementById("coapplicantCheck").checked)

}

const handlemandateCheckbox=(value)=>{
     
  setRunEmandateCheck(value)
  if(value)
  setMandateCheckOpen(!mandateCheckOpen)
}
const handleRunEmandateBox=(value)=>{
    document.getElementById("runEmandate").checked=value
    document.getElementById("runBothEmandate").checked=false
 handlemandateCheckbox(value)
    
}
const handleBothMandateCheckbox=(value)=>{
  setRunBothEmandateCheck(value)
  if(value)
  setBothMandateCheckOpen(!bothMandateCheckOpen)
}
const handleRunBothEmandateBox=(value)=>{
    document.getElementById("runEmandate").checked=false
    document.getElementById("runBothEmandate").checked=value

   handleBothMandateCheckbox(value)
}



//get Emi
  const [backendPan,setBackendPan]=useState(null)
  const [backendAadhaarFront,setBackendAadhaarFront]=useState(null)
  const [backendAadhaarBack,setBackendAadhaarBack]=useState(null)
  const [emiData,setEmiData]=useState(null)
  const updateStatusUrl = `/admin/application/${status==="Approve"?"approve":"assign-fund-source"}`;
  const AddCoApplicantUrl = `/admin/application/add-coapplicant`;

  const popUpStatusForm = () => {
    setStatusOpen(true);
  };


  //get string validation
  const getStringContain=(str)=>{
    return (/\d/.test(str))
  }
  //get email validation
  const validateEmail = (email) => {
    const re = /\S+@\S+\.\S+/;
    return re.test(email);
  };



//get s3 link of uploaded files
const handleAadhaarFrontFileUpload = (item) => {
    
    const data = new FormData();
    data.append('file', item);
    data.append('type', "aadhaar_front");

    axiosInstance
      .post(`/file/upload`, data, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      })
      .then(
        (response) => {
         setBackendAadhaarFront(response.data.data.s3Url)
         document.getElementById("aadhaarFrontUploadButton").className="successFront"
         document.getElementById("aadhaarFrontUploadButton").innerText="Success"
        },
        (error) => {
          alert('Check Mandatory Fields and File format');
        },
      );
  };
const handleAadhaarBackFileUpload = (item) => {

    const data = new FormData();
    data.append('file', item);
    data.append('type', "aadhaar_back");

    axiosInstance
      .post(`/file/upload`, data, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      })
      .then(
        (response) => {
         setBackendAadhaarBack(response.data.data.s3Url)
         document.getElementById("aadhaarBackUploadButton").className="successFront"
         document.getElementById("aadhaarBackUploadButton").innerText="Success"
        },
        (error) => {
          alert('Check Mandatory Fields and File format');
        },
      );
  };
const handlePanFileUpload = (item) => {

    const data = new FormData();
    data.append('file', item);
    data.append('type', "pan");

    axiosInstance
      .post(`/file/upload`, data, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      })
      .then(
        (response) => {
         setBackendPan(response.data.data.s3Url)
         document.getElementById("PanUploadButton").className="successFront"
         document.getElementById("PanUploadButton").innerText="Success"
        },
        (error) => {
          alert('Check Mandatory Fields and File format');
        },
      );
  };

const [cibilcheck,setCibilCheck]=useState(false)

  const handleConsent = () => {
    setOpenOtpConsent(!openOtpConsent);
  }

  const addBijayCoApplicant = async () => {
    if(document.getElementById('coAppName').value.length>0&&document.getElementById('coAppDob').value.length>0&&document.getElementById('coAppNumber').value.length===10&&document.getElementById('coAppZip').value.length>0&&document.getElementById('coAppEmail').value
        && (income || employment==="UNEMPLOYED") )
      {
      setFormLoader(true);
      const statusData = {
        mandatePrimary: runEmandate?true:false,
        checkCibil: cibilcheck?true:false,
        aadhaarFront:backendAadhaarFront?backendAadhaarFront:ocrFormData?.aadhaarImage1,
        dateOfBirth:coAppDob?moment(coAppDob).format('YYYY-MM-DD'):ocrFormData?.dobPerAadhaar?moment(ocrFormData?.dobPerAadhaar).format('YYYY-MM-DD'):moment(ocrFormData?.dobPerPan).format('YYYY-MM-DD'),
        currentCity:coAppCity?coAppCity:ocrFormData?.city,
        currentState:coAppState?coAppState:ocrFormData?.state,
        currentPincode:coAppPincode?coAppPincode:ocrFormData?.pincode,
        aadhaarBack:backendAadhaarBack?backendAadhaarBack:ocrFormData.aadhaarImage2?ocrFormData.aadhaarImage2:null,
        panImage:backendPan?backendPan:ocrFormData?.panImage,
        address:coAppAddress?coAppAddress?.trim():ocrFormData?.address,
        panId: coAppPAN?coAppPAN?.trim():ocrFormData?.panId,
        aadhaarId: coAppAadhaar?coAppAadhaar?.trim():ocrFormData?.aadhaarId,
        applicationId: ApplicantId.ApplicantId.applicationId,
        name: coAppFName?coAppFName?.trim():ocrFormData?.fullNamePerPan,
        mobile: coAppNumber,
        employmentType:
        employment === "EMPLOYED"
          ? "salaried"
          : employment === "SELF_EMPLOYED"
          ? "self-employed"
          : employment,
        employerName: employment==="EMPLOYED"?employerName:"",
        salary: employment==="EMPLOYED"?income:"",
        incomePerMonth: employment==="SELF_EMPLOYED"?income:"",
        typeOfBusiness: employment==="SELF_EMPLOYED"?employerName:"",
        email: coAppEmail?.trim(),
        ...(relationshipStatus !== 'Select Relation with Applicant' && { relation: relationshipStatus }),
        isCoapplicant:flagForMainApplicant,
        mandateForBoth:runBothEmandate,
        rulesStatus:ruleStatus
      };

      try {
        const res = await axiosInstance.post(`${AddCoApplicantUrl}`, statusData, {
          headers: {
            'Content-type': 'application/json',
          },
        })
        if(res.data.message === 'Successful'){
          return res?.data?.data
        }
      } catch (e) {
      }
    }
    else{
      setAlertMessage("Incomplete Information Please Check")
    }
  }
  
  const submitApplicationToInReview = async () => {

    const coAppUserId = await addBijayCoApplicant()
           
    if (!coAppUserId) {
      throw new Error("Failed to fetch co-applicant ID");
    }

    try {
      let authToken = null;

      // 1st Api call
      const authResponse = await axiosInstance.post(`/login/auth`, {
        memberId: coAppUserId,
      });

      authToken = authResponse?.data?.data;

      if (!authToken) {
        throw new Error("Authentication token not received");
      }

      const data = {
        userId: coAppUserId,
        latitude: 0,
        longitude: 0,
        doneBy: 'end-user',
      };

      // 2nd API call
      await axiosInstance.post('/end-user/submit/coapplicant-admin', data, {
        headers: {
          Authorization: `Bearer ${authToken}`,
          'Content-Type': 'application/json',
        },
      });
        alert('Co-Applicant added successfully');
        setTimeout(() => {
          doReload()
        }, 1000)
      }
      catch (error) {
        alert(`Error while processing your request. Please try again. ${error.message}`);
        setTimeout(() => {
          doReload()
        }, 1000)
      }
  };

  const  handleResendCoApplicantConsent =()=>{
 const urlResendConsent=`/end-user/submit/Coapplicant-consent`
  const data={
    userId:ApplicantId?.ApplicantId?.coapplicants?.[0]?.coapplicantId,
    mobile:ApplicantId?.ApplicantId?.coapplicants?.[0]?.mobile
  }
  axiosInstance.post(urlResendConsent,data,{
    headers:{
    }
  })
  .then((res)=>{
  alert(`Resend Consent ${res.data.message}`)})
  .catch((err)=>alert(err));
  

}

  const handleStatusChange = () => {
    if (status === 'Status') {
      alert('NO STATUS CHANGE !');
    } else if (status === 'Approve') {
      if (dateEmi && (dayEmi > 0) && approvalTypeValue) {
        if (approvalTypeValue === 3 && (!remarks || remarks.trim() === '')) {
          alert('Remarks required for exception approval type');
          return;
        }
 setFormLoader(!formLoader);
      setStatusOpen(!formStatusOpen);
      setConfirmationDialog(!confirmationDialog);
      const statusData = {
        applicationId: ApplicantId.ApplicantId.applicationId,
        productId: form.productId,
        loanAmount: null,
        loanTenure: form.tenure,
        emi: emiData,
        emiFirstDate: dateEmi,
        dayOfEmi: dayEmi,
        approvalType: approvalTypeValue,
        ...(approvalTypeValue === 3 && { remarks: remarks }),
      };
       
      axiosInstance
        .post(`${updateStatusUrl}`, statusData, {
          headers: {
            'Content-type': 'application/json',
          },
        })
        .then(
          (res) => {
            if (res.data.message === 'Successful') {
              setConfirmationMessage(`Approved Successfully`);
              setTimeout(() => setConfirmationDialog(!confirmationDialog), 2000);
              setTimeout(() => setConfirmationDialog(false), 2000);
              setTimeout(() => doReload(), 500);
            }
          },
          (error) => {
            alert(' Unsuccessful!!! Check Fields/Format');
             setTimeout(() => setConfirmationDialog(!confirmationDialog), 2000);
              setTimeout(() => setConfirmationDialog(false), 2000);
              setTimeout(() => doReload(), 1000);
          },
        );
      }
     else{
      alert("select emi date")
     }
        
    }else if(status==='Assign Fund Source')
    {
      const statusData = {
        applicationId: ApplicantId.ApplicantId.applicationId,
        fundCode: fundSourceName,
        productId: form.productId,
        loanAmount: null,
        loanTenure: form.tenure,
        emi: emiData,
        emiFirstDate: null,
        dayOfEmi: null,
        rulesStatus:ruleStatus
      };

      axiosInstance
        .post(`${updateStatusUrl}`, statusData, {
          headers: {
            'Content-type': 'application/json',
          },
        })
        .then(
          (res) => {
            if (res.data.message === 'Successful') {
              setConfirmationMessage(`Assigned Fund Source Successfully`);
              setTimeout(() => setConfirmationDialog(!confirmationDialog), 2000);
              setTimeout(() => setConfirmationDialog(false), 2000);
              setTimeout(() => doReload(), 500);
            }
          },
          (error) => {
            alert(' Unsuccessful!!! Check Fields/Format');
             setTimeout(() => setConfirmationDialog(!confirmationDialog), 2000);
              setTimeout(() => setConfirmationDialog(false), 2000);
              setTimeout(() => doReload(), 1000);
          },
        );
    } else if (status === 'Dropped') {
      
      const droppedData = {
        userId: ApplicantId.ApplicantId.userId,
        applicationId: ApplicantId.ApplicantId.applicationId,
        status: ApplicationStatusEnum.Dropped,
        notes: descriptionText,
          };
          if(droppedstate){
            if (droppedstate.message === 'Successful') {
              setFormLoader(!formLoader);
              setStatusOpen(!formStatusOpen);
              setConfirmationDialog(!confirmationDialog);
              setConfirmationMessage('Dropped Successfully');
              setTimeout(() => setConfirmationDialog(!confirmationDialog), 2000);
              setTimeout(() => setConfirmationDialog(false), 2000);
              setTimeout(() => doReload(), 500);
            }else{
              setConfirmationMessage("error");
              setTimeout(() => setConfirmationDialog(!confirmationDialog), 2500);
                setTimeout(() => setConfirmationDialog(false), 2750);
            }
          }else{
            dispatch(userActions.fetchDroppedstatuschange(updateDroppedStatus,droppedData, user),[])
          }
     
    } 
    else if (status === 'Add Co-Applicant') {
    
          
            
            // setFormLoader(!formLoader);
            // setStatusOpen(!formStatusOpen);
            // setConfirmationDialog(!confirmationDialog);
            if(document.getElementById('coAppName').value.length>0&&document.getElementById('coAppDob').value.length>0&&document.getElementById('coAppNumber').value.length===10&&document.getElementById('coAppZip').value.length>0&&document.getElementById('coAppEmail').value)
            {
              if(decode?.clientId==="98ffb18a-9fee-43a5-91a3-4b2b9d9ae361"){
                 handleConsent()
                return
              }
               setFormLoader(!formLoader);
             setIsApiError(false); 
              const statusData = {
                mandatePrimary: runEmandate?true:false,
                checkCibil: true,
                aadhaarFront:backendAadhaarFront?backendAadhaarFront:ocrFormData?.aadhaarImage1,
                dateOfBirth:coAppDob?moment(coAppDob).format('YYYY-MM-DD'):ocrFormData?.dobPerAadhaar?moment(ocrFormData?.dobPerAadhaar).format('YYYY-MM-DD'):moment(ocrFormData?.dobPerPan).format('YYYY-MM-DD'),
                currentCity:coAppCity?coAppCity:ocrFormData?.city,
                currentState:coAppState?coAppState:ocrFormData?.state,
                currentPincode:coAppPincode?coAppPincode:ocrFormData?.pincode,
                aadhaarBack:backendAadhaarBack?backendAadhaarBack:ocrFormData?.aadhaarImage2?ocrFormData?.aadhaarImage2:null,
                panImage:backendPan?backendPan:ocrFormData?.panImage,
                address:coAppAddress?coAppAddress?.trim():ocrFormData?.address,
                panId: coAppPAN?coAppPAN?.trim():ocrFormData?.panId,
                aadhaarId: coAppAadhaar?coAppAadhaar?.trim():ocrFormData?.aadhaarId,
                applicationId: ApplicantId.ApplicantId.applicationId,
                name: coAppFName?coAppFName?.trim():ocrFormData?.fullNamePerPan,
                mobile: coAppNumber,
                employmentType:
                employment === "EMPLOYED"
                  ? "salaried"
                  : employment === "SELF_EMPLOYED"
                  ? "self-employed"
                  : employment,
                employerName: employment==="EMPLOYED"?employerName:"",
                salary: employment==="EMPLOYED"?income:"",
                incomePerMonth: employment==="SELF_EMPLOYED"?income:"",
                typeOfBusiness: employment==="SELF_EMPLOYED"?employerName:"",
                email: coAppEmail?.trim(),
                ...(relationshipStatus !== 'Select Relation with Applicant' && { relation: relationshipStatus }),
                isCoapplicant:flagForMainApplicant,
                mandateForBoth:runBothEmandate,
                rulesStatus: ruleStatus
              };
      
              axiosInstance.post(`${AddCoApplicantUrl}`, statusData, {
                  headers: {
                    'Content-type': 'application/json',
                  },
                })
                .then(
                  (res) => {
                    if (res.data.message === 'Successful') {
                      setConfirmationMessage('Co Applicant Added Successfully');
                      setConfirmationDialog(true);
                      setFormLoader(false);
                      setStatusOpen(false); 
                      setTimeout(() => {
                            setConfirmationDialog(false);
                            doReload();
                        }, 2000);
                    }
                  },
                  (error) => {
                     setFormLoader(false);
                    setIsApiError(true); 
    
                    const errorMessages = error?.response?.data?.message;
                    const formattedErrors = Array.isArray(errorMessages) 
                        ? errorMessages.map((item, key) => <p key={key}>{key + 1}. {item}</p>)
                        : <p>{String(errorMessages) || "An unknown error occurred."}</p>
    
                    setConfirmationMessage(
                      <>
                        <p style={{fontWeight: 'bold'}}>Submission failed. Please check the errors:</p>
                        {formattedErrors}
                      </>
                    );
    
                    setConfirmationDialog(true);
                  },
                
              );
            }
            else
            {
              setAlertMessage("Incomplete Information Please Check")
              setTimeout(() => {
                setAlertMessage(null)
              }, 3000);
            }
              
        }
  
    
    else if(status==="Rejected"){
      if (!rejectionReason) {
        setConfirmationDialog(true);
        setConfirmationMessage("Please select rejection reason");
        return;
      }
      if ((Number(rejectionReason) === 6 || Number(rejectionReason) === 5) && !subRejectionReason) {
        setConfirmationDialog(true);
        setConfirmationMessage("Please select sub rejection reason");
        return;
      }
      if (Number(rejectionReason) === 8 && descriptionText.trim().length < 10) {
        setConfirmationDialog(true);
        setConfirmationMessage("Please enter a Remarks note of at least 10 characters");
        return;
      }
      const rejectedData = {
        userId: ApplicantId.ApplicantId.userId,
        applicationId: ApplicantId.ApplicantId.applicationId,
        status: ApplicationStatusEnum.Rejected,
        notes: descriptionText,
        rejectionReason: Number(rejectionReason),
        rejectionSubReason: (Number(rejectionReason) === 6 || Number(rejectionReason) === 5) ? Number(subRejectionReason) : null,
      };
      if(droppedstate){
        if (droppedstate.message === 'Successful') {
          setFormLoader(!formLoader);
          setStatusOpen(!formStatusOpen);
          setConfirmationDialog(!confirmationDialog);
          setConfirmationMessage('Rejected Successfully');
          setTimeout(() => setConfirmationDialog(!confirmationDialog), 2000);
          setTimeout(() => setConfirmationDialog(false), 2000);
          setTimeout(() => doReload(), 500);
        }else{
          setConfirmationMessage("error");
              setTimeout(() => setConfirmationDialog(!confirmationDialog), 2500);
              setTimeout(() => setConfirmationDialog(false), 2750);
        }
      }else{
        dispatch(userActions.fetchDroppedstatuschange(updateDroppedStatus,rejectedData, user),[])
      }
      
    }
    else if(status==="On Hold"){
     
      const onholdData = {
        userId: ApplicantId.ApplicantId.userId,
        applicationId: ApplicantId.ApplicantId.applicationId,
        status: ApplicationStatusEnum.OnHold,
        notes: descriptionText,
      };
      if(droppedstate){
        if (droppedstate.message === 'Successful') {
          setFormLoader(!formLoader);
          setStatusOpen(!formStatusOpen);
          setConfirmationDialog(!confirmationDialog);
          setConfirmationMessage('Application is in On Hold Now ...');
          setTimeout(() => setConfirmationDialog(!confirmationDialog), 2000);
          setTimeout(() => setConfirmationDialog(false), 2000);
          setTimeout(() => doReload(), 500);
        }else{
          setConfirmationMessage("error");
            setTimeout(() => setConfirmationDialog(!confirmationDialog), 2500);
              setTimeout(() => setConfirmationDialog(false), 2750);
        }
      }else{
        dispatch(userActions.fetchDroppedstatuschange(updateDroppedStatus,onholdData, user),[])
      }
      
    }
    else if (status === 'In Review') {
      const reviewData = {
        userId: ApplicantId.ApplicantId.userId,
        applicationId: ApplicantId.ApplicantId.applicationId,
        status: ApplicationStatusEnum.InReviewAgain,
        notes: descriptionText,
      };
      if(droppedstate){
        if (droppedstate.message === 'Successful') {
          setFormLoader(!formLoader);
          setStatusOpen(!formStatusOpen);
          setConfirmationDialog(!confirmationDialog);
          setConfirmationMessage('Moved To In Review Successfully');
          setTimeout(() => setConfirmationDialog(!confirmationDialog), 2000);
          setTimeout(() => setConfirmationDialog(false), 2000);
          setTimeout(() => doReload(), 500);
        }else{
            setConfirmationMessage("error");
            setTimeout(() => setConfirmationDialog(!confirmationDialog), 2500);
            setTimeout(() => setConfirmationDialog(false), 2750);
        }
      }else{
        dispatch(userActions.fetchDroppedstatuschange(updateDroppedStatus,reviewData, user),[]) 
      }
    }
  };
  useEffect(()=>{
    handleStatusChange();
  },[droppedstate])

  useEffect(() => {
    if (ApplicantId?.ApplicantId?.emiFirstDate) {
      const formatted = moment(ApplicantId.ApplicantId.emiFirstDate).format('YYYY/MM/DD');
      setEmiDate(formatted);
      setEmiDay(parseInt(formatted.split('/')[2], 10));
    }
  }, [ApplicantId]);
  //set colender fund source
  const [colenderFundSource,setColenderFundSource]=useState(null)
  const getUserInfo=`/admin/user-info`
const getColenderFundSource=()=>{

      axiosInstance.get(getUserInfo,{
        headers:{
        }
      }).then((res)=>{
      if(res.data.data.colenderId)
      {
        axiosInstance.get(`/fund_source/fund_code?fundCode=${res.data.data.colenderId}`,{
        headers:{
        }
      })
        .then((result)=>
        setColenderFundSource(result.data.data.fundCode))
      }
    })
  }
  const handleApproveApi = (x, y, z) => {
    setRejectionReason("");
    setSubRejectionReason("");
    
    setStatus(x.target.innerText);
    axiosInstance
      .get(urlApproveApiProd, {
        headers: {
        },
      })
      .then((res) =>{   
         //setting loan amount
        // setLoanAmount(z)
        // if(x.target.innerText==="Approve")
        // {

        //   document.getElementById("loanAmount").defaultValue=z;
        // }
        setProdArray(res.data.data)
      }
      );


    if(decode.role==='co_lender')
    {
      getColenderFundSource()
    }
    else{
axiosInstance
      .get(urlApproveApiFund, {
        headers: {
        },
      })
      .then((res) => setFundSourceArray(res.data.data));
    }
        
  };
  const handleToggle = () => {
    setDropDownOpen(!dropDownOpen);
  };
  const handleRelationshipToggle = () => {
    setRelationshipStatusDropdown(!relationshipStatusDropdown);
  };

  const handleFundToggle = () => {
    setFundDropDownOpen(!fundDropDownOpen);
  };
  const handleDescriptionText = (text) => {
    setDescriptionText(text);
  };




  //upload Docs 
  let aadhaarFrontPreview='';
  aadhaarFrontPreview = aadhaarFrontUpload ? URL.createObjectURL(new Blob([aadhaarFrontUpload], { type: 'application/jpg' })) : '#';
  let aadhaarBackPreview='';
  aadhaarBackPreview = aadhaarBackUpload ? URL.createObjectURL(new Blob([aadhaarBackUpload], { type: 'application/jpg' })) : '#';
  let pancardPreview='';
  pancardPreview = panUpload ? URL.createObjectURL(new Blob([panUpload], { type: 'application/jpg' })) : '#';


  //handleForm Reset
const handleFormReset=()=>{
  setRelationshipStatus("Select Relation with Applicant");
  setAadhaarFrontUpload(null);
  setAadhaarBackUpload(null);
  setPanUpload(null);
  aadhaarBackPreview="";
  aadhaarFrontPreview="";
  pancardPreview="";
  setOCRFormData(null);
  setOCRReadDone(false);
  setCoAppAadhaar(null);
  setCoAppEmail(null);
  setCoAppNumber(null);
  setCoAppPAN(null);
  setCoAppFName("");
  

}

const handleOnLoad=(e)=>{
  
  const selectedStatus =(e.target.innerText)
  setStatus(selectedStatus);
  if (selectedStatus !== "Rejected") {
    setRejectionReason("");
    setSubRejectionReason("");
  }
handleFormReset()
}

const id = ApplicantId.ApplicantId.applicationId


const name = ApplicantId.ApplicantId.name


const handleEmploymentChange = (e) => {
  setEmployment(e.target.value)
}
 
  
  return (
    <div>
      <img  onClick={() => popUpStatusForm()} style={{cursor:'pointer',width:'1.1vw'}} src={action3} alt="resend consent"/>
      <Modal isOpen={confirmationDialog} toggle={() => setConfirmationDialog(false)}>
         <ModalHeader toggle={() => setConfirmationDialog(false)}>
             {isApiError ? 'Submission Error' : 'Waiting For Confirmation'}
         </ModalHeader>
         <ModalBody>
             {confirmationMessage}
         </ModalBody>
         {isApiError && (
             <ModalFooter>
                 <Button color="secondary" onClick={() => setConfirmationDialog(false)}>
                     Close
                 </Button>
             </ModalFooter>
         )}
     </Modal>
      <Modal style={{
        
        
         
        
       height:"100%",
       overflowY:"auto",
        width:"100%",
        borderRadius:"10px",
      }} isOpen={formStatusOpen} size="xl">
            <div style={{display:"flex",flexDirection:"row",justifyContent:'space-between',alignItems:'center', height:'60px',paddingLeft:'12px', paddingRight:'12px', backgroundColor:"#E9E9E9",borderTopLeftRadius:'10px',borderTopRightRadius:'10px'}}>
                <p style={{fontFamily:"Inter-Medium",fontSize:'14px', marginTop:'12px'}}>Update Status Here ( Process to <span style={{fontFamily:"Inter-Medium",color:'#D32028'}}>{status}</span> )</p>
                <img src={close} style={{cursor:'pointer'}} onClick={() => {
                  // setStatus("Select Status")
                  setStatusOpen(!formStatusOpen)
                }}/>
            </div>
           
            <div style={{marginTop:'10px'}}>
            <div style={{display:"flex",flexDirection:"row",justifyContent:"space-between",backgroundColor:'#FCF0F1',width:"100%",borderRadius:"10px"}}>
              <p style={{marginLeft:"15px",fontFamily:"Inter-Medium",fontSize:"14px",color:"#D32028"}}>Application ID <br/><span style={{fontFamily:"Inter-Medium",fontSize:"14px",color:"black"}}>{id}</span></p>
               <p style={{marginRight:"15px",fontFamily:"Inter-Medium",fontSize:"14px",color:"#D32028"}}> Applicant Name<br/><span style={{fontFamily:"Inter-Medium",fontSize:"14px",color:"black"}}>{name}</span></p>
            </div>
         
          
        </div>
       
        <ModalBody>
          <Form>
            <FormGroup>
              <div style={{ display: "flex", gap: "30px", alignItems: "flex-start" }}>
                <div>
            <p style={{lineHeight:'10px',fontFamily:"Inter-Medium",fontSize:'14px'}}>Select Status*</p>
              <Dropdown isOpen={dropDownOpen} toggle={() => handleToggle()}>
                <DropdownToggle style={{lineHeight:'10px',textAlign:"left",height:'40px',width:'330px',backgroundColor:'white',color:'gray',fontFamily:"Inter-Medium",fontSize:'14px'}} >
                  {status}<span style={{ position: 'absolute',left:"300px", top: '50%', transform: 'translateY(-50%)' }}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12">
                      <path fill="currentColor" d="M1.5 4.5l4.5 4.5 4.5-4.5z" />
                    </svg>
                  </span>
                </DropdownToggle>
                <DropdownMenu>
                  <DropdownItem disabled={(decode?.clientId === '98ffb18a-9fee-43a5-91a3-4b2b9d9ae361' && (ApplicantId?.ApplicantId?.noVerification || decode?.role==="exec"))} style={{fontFamily:"Inter-Medium",fontSize:'14px'}}onClick={(e) => handleApproveApi(e, ApplicantId.ApplicantId.instituteId,ApplicantId.ApplicantId.courseFees)}>
                  Approve
                  </DropdownItem>
                  {/* <DropdownItem style={{fontFamily:"Inter-Medium",fontSize:'14px'}}onClick={(e) => handleApproveApi(e, ApplicantId.ApplicantId.instituteId,ApplicantId.ApplicantId.courseFees)}>
                  Assign Fund Source
                  </DropdownItem> */}
                  <DropdownItem  style={{fontFamily:"Inter-Medium",fontSize:'14px'}}onClick={(e) => handleOnLoad(e)}>
                  Rejected
                  </DropdownItem>
                  <DropdownItem style={{fontFamily:"Inter-Medium",fontSize:'14px'}} onClick={(e) => handleOnLoad(e)}>
                  Add Co-Applicant
                  </DropdownItem>
                 {decode?.clientId !== '98ffb18a-9fee-43a5-91a3-4b2b9d9ae361' &&  ApplicantId?.ApplicantId?.coapplicants?.[0]?.coapplicantId.length>0  && (
                      <DropdownItem
                        style={{ fontFamily: "Inter-Medium", fontSize: "14px" }}
                        onClick={(e) => handleOnLoad(e)}
                      >
                        Resend Consent to Co-Applicant
                      </DropdownItem>
                    )}
                  <DropdownItem style={{fontFamily:"Inter-Medium",fontSize:'14px'}} onClick={(e) => handleOnLoad(e)}>
                  Dropped
                  </DropdownItem>
                  <DropdownItem style={{fontFamily:"Inter-Medium",fontSize:'14px'}} onClick={(e) => handleOnLoad(e)}>
                  On Hold
                  </DropdownItem>
                  {decode?.clientId === '98ffb18a-9fee-43a5-91a3-4b2b9d9ae361' && decode?.role==='admin' && 
                  <DropdownItem style={{fontFamily:"Inter-Medium",fontSize:'14px'}} onClick={(e) => handleOnLoad(e)}>
                    In Review
                  </DropdownItem> } 
                </DropdownMenu>
              </Dropdown>
</div>
                {status === "Rejected" && (
                  <div>
                    <p style={{ lineHeight: '10px', fontFamily: "Inter-Medium", fontSize: '14px' }}>
                      Rejection Reason*
                    </p>

                    <select
                      value={rejectionReason}
                      onChange={(e) => {
                        setRejectionReason(e.target.value);
                        setSubRejectionReason("");
                      }}
                      style={{
                        lineHeight: '10px',
                        textAlign: "left",
                        height: '40px',
                        width: '330px',
                        backgroundColor: 'white',
                        color: 'gray',
                        fontFamily: "Inter-Medium",
                        fontSize: '14px',
                        borderRadius: "5px",
                        border: "1px solid #ced4da",
                        paddingLeft: "10px",
                      }}
                    >
                      <option value="">Select Rejection Reason</option>
                      {rejectionReasons.map((reason) => (
                        <option key={reason.value} value={reason.value}>
                          {reason.label}
                        </option>
                      ))}
                    </select>
                  </div>
                )}
                {status === "Rejected" && (Number(rejectionReason) === 6 || Number(rejectionReason) === 5) && (
                  <div>
                    <p
                      style={{
                        lineHeight: '10px',
                        fontFamily: "Inter-Medium",
                        fontSize: '14px'
                      }}
                    >
                      Sub Rejection Reason*
                    </p>

                    <select
                      value={subRejectionReason}
                      onChange={(e) => setSubRejectionReason(e.target.value)}
                      style={{
                        lineHeight: '10px',
                        textAlign: "left",
                        height: '40px',
                        width: '330px',
                        backgroundColor: 'white',
                        color: 'gray',
                        fontFamily: "Inter-Medium",
                        fontSize: '14px',
                        borderRadius: "5px",
                        border: "1px solid #ced4da",
                        paddingLeft: "10px",
                      }}
                    >
                      <option value="">
                        Select Sub Rejection Reason
                      </option>

                      {(Number(rejectionReason) === 6 ? subRejectionReasons : bankAnalysisSubReasons).map((reason) => (
                        <option key={reason.value} value={reason.value}>
                          {reason.label}
                        </option>
                      ))}
                    </select>
                  </div>
                )}
              </div>
              {/* {
                status==='Request Co-Applicant'?
                <div style={{marginTop:'1em'}}>
                  <p style={{textAlign:'center',fontWeight:'600',backgroundColor:'aliceBlue',padding:'0.5em'}}>ON<span style={{color:'red'}}> SAVE AND SUBMIT </span><br/>A SMS WILL BE  SENT<br/>TO THE APPLICANT<p style={{textDecoration:'underline'}}> TO FILL
                    CO-APPLICANT DETAILS ! </p></p> 
                </div>:null

              } */}
              {status === 'Approve' ? (
                <div style={{ display: 'flex', justifyContent: 'space-between', gap: '20px', marginTop: '10px', alignItems: 'flex-start' ,padding:'10px'}}>
                  <div style={{ backgroundColor: '#FEEDEE', padding: '1em', borderRadius: '10px', width: '300px', minHeight: '120px', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>
                    <strong style={{ marginBottom: '8px' }}>EMI First Date</strong>
                    <Datetime
                      closeOnSelect={true}
                      id="fistDateOfEmi"
                      dateFormat="YYYY/MM/DD"
                      timeFormat={false}
                      value={dateEmi ? moment(dateEmi, 'YYYY/MM/DD') : null}
                      isValidDate={(current) => current.isAfter(moment().add(15, 'days'))}
                      onChange={(event) => {
                        if (typeof event === 'string') {
                          setEmiDate(null);
                        } else if (event && event.format) {
                          const formatted = event.format('YYYY/MM/DD');
                          setEmiDate(formatted);
                          setEmiDay(parseInt(formatted.split('/')[2], 10));
                        }
                      }}
                      locale="en-gb"
                      inputProps={{ placeholder: 'select date', style: { height: '30px', fontSize: '14px', width: '100%' } }}
                      className='item-input'
                    />
                  </div>

                  <div style={{ backgroundColor: '#FEEDEE', padding: '1em', borderRadius: '10px', width: '300px', minHeight: '120px', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>
                    <strong style={{ marginBottom: '8px' }}>Day of EMI</strong>
                    <Input
                      type="number"
                      id="dayOfEmi"
                      onWheel={(e) => {
                        e.target.blur();
                        e.stopPropagation();
                        setTimeout(() => {
                          e.target.focus();
                        }, 0);
                      }}
                      placeholder="enter day(1-30)"
                      value={dayEmi || ''}
                      onChange={(e) => setEmiDay(e.target.value)}
                      className='item-input'
                      style={{ width: '100%' }}
                    />
                  </div>

                  <div style={{ backgroundColor: '#FEEDEE', padding: '1em', borderRadius: '10px', width: '300px', minHeight: '120px', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'flex-start' }}>
                    <strong style={{ marginBottom: '8px' }}>Approval Type</strong>
                    <Dropdown isOpen={approvalTypeDropdownOpen} toggle={() => setApprovalTypeDropdownOpen(!approvalTypeDropdownOpen)}>
                      <DropdownToggle style={{ height: '40px', width: '100%', backgroundColor: 'white', color: 'gray', fontFamily: 'Inter-Medium', fontSize: '14px' }} caret>
                        {approvalType}
                      </DropdownToggle>
                      <DropdownMenu>
                        <DropdownItem onClick={() => { setApprovalType('Manual'); setApprovalTypeValue(2); setApprovalTypeDropdownOpen(false); }}>
                          Manual
                        </DropdownItem>
                        <DropdownItem onClick={() => { setApprovalType('Exception'); setApprovalTypeValue(3); setApprovalTypeDropdownOpen(false); }}>
                          Exception
                        </DropdownItem>
                      </DropdownMenu>
                    </Dropdown>

                    {approvalTypeValue === 3 && (
                      <div style={{ marginTop: '12px', width: '100%' }}>
                        <strong style={{ display: 'block', marginBottom: '6px' }}>Remarks</strong>
                        <Input type="text" value={remarks} onChange={(e) => setRemarks(e.target.value)} placeholder="Enter remarks (required for exception)" className='item-input' style={{ width: '100%' }} />
                      </div>
                    )}
                  </div>
                </div>
              ) : (
                <></>
              )}
              {
                status==='Assign Fund Source'?
                <>
                  <Dropdown isOpen={fundDropDownOpen} toggle={() => handleFundToggle()}>
                        <DropdownToggle style={{border:"none", marginTop: '1em',fontFamily:"Inter-Medium",fontSize:'14px',backgroundColor:'#D32028' }} caret >
                          {decode.role==='co_lender'?colenderFundSource:fundSourceName}
                        </DropdownToggle>
                        {decode.role==='co_lender'?null:<DropdownMenu>
                          {fundSourceArray.map((item, idx) => {
                            return (
                              // eslint-disable-next-line react/no-array-index-key
                              <DropdownItem
                                key={idx}
                                onClick={(e) => setFundSourceName(e.target.innerText)}
                              >
                                {item}
                              </DropdownItem>
                            );
                          })}
                        </DropdownMenu>}
                      </Dropdown>
                </>:
                (
                  <></>
                )
              }
  {status === 'Add Co-Applicant'?!ocrReadDone? 
                 isLoading ? (
                                          <Box style={{ display: 'flex',alignItems:'center',justifyContent:'center',padding:'15%'}}>
                                          <CircularProgress />
                                        </Box>
                                        ): (    
        <><div style={{display:'flex',justifyContent: 'space-evenly',marginTop:'1em'}}>
          <div style={{display:'block'}}>
          <p style={{fontFamily:'Inter-Medium',fontSize:'14px'}}>Upload Aadhaar Front</p>
          <Input className="ocrUpload"   onChange={(e)=>previewOcrAadhaarFront(e)} type="file"/>
          <p style={{textAlign:'center',fontFamily:'Inter-Medium',fontSize:'14px'}}>Preview</p>

          <img style={{border:'none',maxWidth:'18em',height:'15em'}} id="ocrAadhaarFOutput" alt=""/>
          </div>
          <div style={{display:'block'}}>
          <p style={{fontFamily:'Inter-Medium',fontSize:'14px'}}>Upload Aadhaar Back</p>
          
          <Input className="ocrUpload"   onChange={(e)=>previewOcrAadhaarBack(e)}type="file"/>
          <p style={{textAlign:'center',fontFamily:'Inter-Medium',fontSize:'14px'}}>Preview</p>

          <img style={{marginLeft:'1em',border:"0",maxWidth: '18em',height:'15em'}} id="ocrAadhaarBOutput" alt=""/>

          </div>

          <div style={{display:'block'}}>
          <p style={{fontFamily:'Inter-Medium',fontSize:'14px'}}>Upload PAN</p>

          <Input className="ocrUpload"   onChange={(e)=>previewOcrPan(e)}type="file"/>
          <p style={{textAlign:'center',fontFamily:'Inter-Medium',fontSize:'14px'}}>Preview</p>
          <img style={{marginLeft:'1em',border:'none',maxWidth:'18em',height:'15em'}} id="ocrPanOutput" alt=""/>

          </div>

         
          </div>
            <div style={{alignSelf: 'center',marginLeft:'40%'}}>
            <button onClick={()=>readOcr()} style={{border:'none',borderRadius:'10px',width:'15em',backgroundColor:"#D22129",color:'white',fontFamily:'Inter-Medium',fontSize:'14px'}}  type="button">Trigger Coapplicant OCR</button>
            </div></> ):  <div style={{ display: 'flex' }}>
                  <div style={{ display: 'block' }}>
                    <Dropdown
                      style={{ marginTop: '1em' }}
                      isOpen={relationshipStatusDropdown}
                      toggle={() => handleRelationshipToggle()}
                    >
                      <DropdownToggle style={{backgroundColor:'#d32028',fontFamily:'Inter-Medium',fontSize:'14px'}} caret>
                        {relationshipStatus}
                      </DropdownToggle>
                      <DropdownMenu>
                        <DropdownItem style={{fontFamily:'Inter-Medium',fontSize:'14px'}}   onClick={(e) => setRelationshipStatus(e.target.innerText)}>
                          Spouse
                        </DropdownItem>
                        <DropdownItem style={{fontFamily:'Inter-Medium',fontSize:'14px'}}  onClick={(e) => setRelationshipStatus(e.target.innerText)}>
                          Parent
                        </DropdownItem>
                        <DropdownItem style={{fontFamily:'Inter-Medium',fontSize:'14px'}}  onClick={(e) => setRelationshipStatus(e.target.innerText)}>
                          Guardian
                        </DropdownItem>
                        <DropdownItem style={{fontFamily:'Inter-Medium',fontSize:'14px'}}  onClick={(e) => setRelationshipStatus(e.target.innerText)}>
                          Friend
                        </DropdownItem>
                         <DropdownItem style={{fontFamily:'Inter-Medium',fontSize:'14px'}}  onClick={(e) => setRelationshipStatus(e.target.innerText)}>
                          Sibling
                        </DropdownItem>
                      </DropdownMenu>
                    </Dropdown>
                    <div style={{display:'flex',justifyContent:'space-between'}}>
                    <p style={{ marginTop: '1em', fontWeight: '700',fontFamily:'Inter-Medium',fontSize:'14px',width:'8em',lineHeight:'1.5em' }}> Co-Applicant Name</p>
                    <Input
                    defaultValue={ocrFormData?.fullNamePerPan}
                    valid={getStringContain(coAppFName)}
                    invalid={getStringContain(coAppFName)}
                      type="text"
                      id="coAppName"
                      placeholder="Co Applicant Name"
                      onChange={(e) => setCoAppFName(e.target.value)}
                      style={{
                        height: '30px',
                        width: '240px',fontFamily:'Inter-Medium',fontSize:'14px',
                        margin:'18px',
                        borderRadius: '5px',
                      }}
                    />
                </div>
                 <div style={{display:'flex',justifyContent:'space-between'}}>
                    <p style={{ marginTop: '1em', fontWeight: '700',fontFamily:'Inter-Medium',fontSize:'14px',width:'8em',lineHeight:'1.5em'}}>Co-Applicant DOB</p>
                    <Input
                      defaultValue={ocrFormData?.dobPerAadhaar?ocrFormData?.dobPerAadhaar:ocrFormData?.dobPerPan}
                      type="date"
                      id="coAppDob"
                      placeholder="Date of Birth"
                      onChange={(e) => setCoAppDob(e.target.value)}
                      style={{
                        height: '30px',
                        width: '200px',fontFamily:'Inter-Medium',fontSize:'14px',
                        margin:'18px',
                        borderRadius: '5px',
                      }}
                    />
                  </div>
                 <div style={{display:'flex',justifyContent:'space-between'}}>
                    <p style={{ marginTop: '1em', fontWeight: '700',fontFamily:'Inter-Medium',fontSize:'14px',width:'8em',lineHeight:'1.5em'}}>Co-Applicant Phone Number</p>
                    <Input
                    valid={coAppNumber?coAppNumber.length===10?true:false:""}
                     
                    
                      type="number"
                      id="coAppNumber"
                      placeholder="Phone number of Co Applicant"
                      onChange={(e) => setCoAppNumber(e.target.value)}
                      style={{
                        height: '30px',
                        width: '240px',fontFamily:'Inter-Medium',fontSize:'14px',
                        margin:'18px',
                        borderRadius: '5px',
                      }}
                    />
                  </div>
                  {/* Work Details */}
                  <div>
                      <p style={{fontWeight: 'bold', fontSize: '14px', fontFamily:'Inter-Medium'}}>Employment</p>
                      <div style={{display:'flex', justifyContent:'center', marginTop: -10}}>
                        <RadioGroup
                          aria-labelledby="demo-controlled-radio-buttons-group"
                          name="controlled-radio-buttons-group"
                          row 
                          value={employment}
                          onChange={handleEmploymentChange}
                        >
                          <FormControlLabel value="EMPLOYED" control={<Radio size='small' />} label="Salaried" sx={{mr:5,  '& .MuiFormControlLabel-label': { fontFamily: 'Inter-Medium', fontWeight:'bold', fontSize: '14px' }}}/>
                          <FormControlLabel value="SELF_EMPLOYED" control={<Radio  size='small' />} label="Self Employed" sx={{mr:5, '& .MuiFormControlLabel-label': { fontFamily: 'Inter-Medium', fontWeight:'bold', fontSize: '14px' }}}/>
                          <FormControlLabel value="UNEMPLOYED" control={<Radio  size='small' />} label="Unemployed" sx={{mr:5, '& .MuiFormControlLabel-label': { fontFamily: 'Inter-Medium', fontWeight:'bold', fontSize: '14px' }}}/>
                        </RadioGroup>
                      </div>
                      {employment==='EMPLOYED' &&
                      <>
                      <div style={{display:'flex', justifyContent:'space-between'}}>
                        <p style={{ marginTop: '1.5em', fontWeight: '700',fontFamily:'Inter-Medium',fontSize:'14px',width:'8em',lineHeight:'1.5em'}}>Employer Name</p>
                        <Input
                          id="employerName"
                          placeholder="Enter Employer Name"
                          onChange={(e) => setEmployerName(e.target.value)}
                          style={{
                            height: '30px',
                            width: '240px',fontFamily:'Inter-Medium',fontSize:'14px',
                            margin:'18px',
                            borderRadius: '5px',
                          }}
                        />
                        </div>
                        <div style={{display:'flex', justifyContent:'space-between'}}>
                        <p style={{ marginTop: '1.5em', fontWeight: '700',fontFamily:'Inter-Medium',fontSize:'14px',width:'8em',lineHeight:'1.5em'}}>Salary</p>
                        <Input
                          id="salary"
                          type="number"
                          placeholder="Enter Salary Per Month"
                          onChange={(e) => setIncome(e.target.value)}
                          style={{
                            height: '30px',
                            width: '240px',fontFamily:'Inter-Medium',fontSize:'14px',
                            margin:'18px',
                            borderRadius: '5px',
                          }}
                        />
                        </div>

                        </>
                      }
                      {employment==='SELF_EMPLOYED' && 
                      <>
                      <div style={{display:'flex', justifyContent:'space-between'}}>
                        <p style={{ marginTop: '1em', fontWeight: '700',fontFamily:'Inter-Medium',fontSize:'14px',width:'8em',lineHeight:'1.5em'}}>Type Of Business</p>
                        <Input
                          id="business"
                          placeholder="Enter Business Type"
                          onChange={(e) => setEmployerName(e.target.value)}
                          style={{
                            height: '30px',
                            width: '240px',fontFamily:'Inter-Medium',fontSize:'14px',
                            margin:'18px',
                            borderRadius: '5px',
                          }}
                        />
                        </div>
                        <div style={{display:'flex', justifyContent:'space-between'}}>
                        <p style={{ marginTop: '1em', fontWeight: '700',fontFamily:'Inter-Medium',fontSize:'14px',width:'8em',lineHeight:'1.5em'}}>Income Per Month</p>
                        <Input
                          id="income"
                          type="number"
                          placeholder="Enter Income Per Month"
                          onChange={(e) => setIncome(e.target.value)}
                          style={{
                            height: '30px',
                            width: '240px',fontFamily:'Inter-Medium',fontSize:'14px',
                            margin:'18px',
                            borderRadius: '5px',
                          }}
                        />
                        </div>

                        </>
                      }
                  
                  </div>
                      <div style={{display:'block',marginTop:'2em'}}>
                      <p style={{ marginTop: '0.5em', fontWeight: '700',fontFamily:'Inter-Medium',fontSize:'14px' }}>Upload Aadhaar (Front)</p>
                      <Input
                        type="file"
                        id="inp6"
                        disabled={ocrFormData?.aadhaarImage1?true:false}
                       
                        onChange={(e) => setAadhaarFrontUpload(e.target.files[0])}
                        style={{
                          height: '30px',
                          width: '300px',fontFamily:'Inter-Medium',fontSize:'14px',

                          borderRadius: '50px',
                        }}
                      />
                     { ocrFormData?.aadhaarImage1?<><img src={aadhaarImage1Url} alt="No File Uploaded" style={{borderRadius:'1em',backgroundColor:'#E8E8E8',margin:'15px',width:'20em',height:'10em',border:'1px dashed black',padding:'0.5em',}}/>
                     
                     </>
                     :
                     aadhaarFrontUpload?<><img src={aadhaarFrontPreview} alt="No File Uploaded" style={{borderRadius:'1em',backgroundColor:'#E8E8E8',margin:'15px',width:'20em',height:'10em',border:'1px dashed black',padding:'0.5em',}}/>
                     <Button id="aadhaarFrontUploadButton" className="infoFront" onClick={()=>handleAadhaarFrontFileUpload(aadhaarFrontUpload)}> Upload</Button></>: <p style={{color:'red',fontWeight:'550',marginTop:'-4em',fontFamily:'Inter-Medium',fontSize:'14px'}}>( Upload To See Preview )</p>}
                      </div>

                       <div style={{display:'block'}}>   
                      <p style={{ marginTop: '0.5em', fontWeight: '700',fontFamily:'Inter-Medium',fontSize:'14px' }}>Upload Aadhaar (Back Side)</p>
                      <Input
                        type="file"
                        id="inp8"
                         disabled={ocrFormData?.aadhaarImage2?true:false}
                        onChange={(e) => setAadhaarBackUpload(e.target.files[0])}
                        style={{
                          height: '30px',
                          width: '300px',fontFamily:'Inter-Medium',fontSize:'14px',

                          borderRadius: '50px',
                        }}
                      />
                       {ocrFormData?.aadhaarImage2?<><img src={aadhaarImage2Url}alt="No File Uploaded" style={{borderRadius:'1em',backgroundColor:'#E8E8E8',margin:'15px',border:'1px dashed black',padding:'0.5em',width:'20em',height:'10em',}}/></>
                       :
                        aadhaarBackUpload ?<>
                        <img src={aadhaarBackPreview} alt="No File Uploaded" style={{borderRadius:'1em',backgroundColor:'#E8E8E8',margin:'15px',border:'1px dashed black',padding:'0.5em',width:'20em',height:'10em',}}/><Button id="aadhaarBackUploadButton" className="infoBack" onClick={()=>handleAadhaarBackFileUpload(aadhaarBackUpload)}> Upload</Button></>:<p style={{padding:'5px',fontFamily:'Inter-Medium',fontSize:'14px'}}>Upload to see Preview</p>}

                        </div>
                  </div>
                  <div style={{ display: 'block', borderLeft:'1px dashed black',marginLeft: '4em',paddingLeft:'4em' }}>
                   <div style={{display:'flex',justifyContent:'space-between',}}>
                    <p style={{ marginTop: '1em', fontWeight: '700',fontFamily:'Inter-Medium',fontSize:'14px' }}>Co-Applicant Email</p>
                    <Input
                       valid={validateEmail(coAppEmail)}
                   
                      type="text"
                      id="coAppEmail"
                      placeholder="Enter Co Applicant Email"
                      onChange={(e) => setCoAppEmail(e.target.value)}
                      style={{
                      height: '30px',
                        width: '240px',margin:'18px',fontFamily:'Inter-Medium',fontSize:'14px',

                        borderRadius: '5px',
                      }}
                    />
                    </div>
                     <div style={{display:'flex',justifyContent:'space-between',width:'15em'}}>
                    <p style={{ marginTop: '1em', fontWeight: '700',fontFamily:'Inter-Medium',fontSize:'14px' }}>PAN</p>
                    <Input
                    valid={coAppPAN?coAppPAN.length===10:""}
                      defaultValue={ocrFormData?.panId}
                      type="text"
                      id="coAppPan"
                      placeholder="Enter PAN of Co Applicant"
                      onChange={(e) => setCoAppPAN(e.target.value)}
                      style={{
                        height: '30px',
                        width: '240px',margin:'18px',
                         textTransform: "uppercase",fontFamily:'Inter-Medium',fontSize:'14px',
                        borderRadius: '5px',
                      }}
                    />
                    </div>
                     <div style={{display:'flex',justifyContent:'space-between',width:'15em'}}>
                    <p style={{ marginTop: '1em', fontWeight: '700',fontFamily:'Inter-Medium',fontSize:'14px' }}>Aadhaar</p>
                    <Input
                      valid={coAppAadhaar?coAppAadhaar.length===12:""}
                      defaultValue={ocrFormData?.aadhaarId}
                      type="text"
                      id="inp5"
                      placeholder="Enter Aadhaar of Co Applicant"
                      onChange={(e) => setCoAppAadhaar(e.target.value)}
                      style={{
                      height: '30px',
                        width: '240px',margin:'18px',fontFamily:'Inter-Medium',fontSize:'14px',

                        borderRadius: '5px',
                      }}
                    />
                  </div>
                    <div
                      style={{ display: 'block', justifyContent: 'space-between', marginTop: '1em',fontFamily:'Inter-Medium',fontSize:'14px' }}
                    >
                    
                      
                       <div style={{display:'block'}}>
                      <p style={{ marginTop: '0.5em', fontWeight: '700' ,fontFamily:'Inter-Medium',fontSize:'14px'}}>Upload PAN </p>
                      <Input
                        type="file"
                        id="inp9"
                         disabled={ocrFormData?.panImage?true:false}
                        onChange={(e) => setPanUpload(e.target.files[0])}
                        style={{
                          height: '30px',
                          width: '300px',fontFamily:'Inter-Medium',fontSize:'14px',

                          borderRadius: '50px',
                        }}
                      />
                       {
                          
                        ocrFormData?.panImage?<><img src={panImageUrl} alt="No File Uploaded" style={{borderRadius:'1em',backgroundColor:'#E8E8E8',margin:'15px',width:'20em',height:'10em',border:'1px dashed black',padding:'0.5em',}}/></>
                        :
                        
                         panUpload?<><img src={pancardPreview} alt="No File Uploaded" style={{borderRadius:'1em',backgroundColor:'#E8E8E8',margin:'15px',width:'20em',height:'10em',border:'1px dashed black',padding:'0.5em',}}/><Button id="PanUploadButton" className="infoBack"  onClick={()=>handlePanFileUpload(panUpload)}> Upload</Button></>:<p style={{padding:'5px',fontFamily:'Inter-Medium',fontSize:'14px'}}>Upload file to see preview</p>
                       }
                       </div>

                        <div style={{display:'flex',justifyContent:'space-between'}}>
                        <p style={{fontWeight:'bold',fontFamily:'Inter-Medium',fontSize:'14px',width:'8em'}}>Co-Applicant Address</p>
                         <Input
                            defaultValue={ocrFormData?.address}
                            type="text"
                            id="inp23"
                            placeholder="Enter Co Applicant Address"
                            onChange={(e) => setCoAppAddress(e.target.value)}
                            style={{
                              height: '80px',
                              width: '350px',fontFamily:'Inter-Medium',fontSize:'14px',
                              borderRadius: '5px',
                              }}
                    />
                      </div>
                        <div style={{display:'flex',justifyContent: 'space-between',width:'22em',marginTop:'1em'}}>
                      <strong> City</strong>

                        <Input
                            defaultValue={ocrFormData?.city}
                            type="text"
                            id="inp23"
                            placeholder="City"
                            onChange={(e) => setCoAppCity(e.target.value)}
                            style={{
                              height: '40px',
                              width: '150px',fontFamily:'Inter-Medium',fontSize:'14px',
                              borderRadius: '5px',
                              }}
                    />
                  </div>
                    <div style={{display:'flex',justifyContent: 'space-between',width:'22em',marginTop:'1em'}}>
                      <strong> State</strong>
                      <select value={coAppState ||states.find( s => s.toLowerCase() === (ocrFormData?.state || "").toLowerCase()) || ""  } onChange={(e) => setCoAppState(e.target.value)}
                        style={{
                          height: '40px',
                          width: '150px',fontFamily:'Inter-Medium',fontSize:'14px',
                          borderRadius: '5px',
                          }}>
                      {
                        states?.map((item)=>{
                          return(
                            <option name={item} value={item}>{item}</option>
                          )
                        })
                      }

                      </select>
                        {/* <Input
                            defaultValue={ocrFormData?.state}
                            type="text"
                            id="inp23"
                            placeholder="State"
                            onChange={(e) => setCoAppState(e.target.value)}
                            style={{
                              height: '40px',
                              width: '150px',fontFamily:'Inter-Medium',fontSize:'14px',
                              borderRadius: '5px',
                              }}
                    /> */}
                  </div>
                  
                  <div style={{display:'flex',justifyContent: 'space-between',width:'22em',marginTop:'1em'}}>
                   <strong> ZIP</strong>
                         <Input
                            defaultValue={ocrFormData?.pincode}
                            type="text"
                            id="coAppZip"
                            placeholder="Pincode"
                            onChange={(e) => setCoAppPincode(e.target.value)}
                            style={{
                              height: '40px',
                              width: '150px',fontFamily:'Inter-Medium',fontSize:'14px',
                              borderRadius: '5px',
                              }}
                    />
                  </div>
                    </div>
                        <div style={{display:'flex',backgroundColor:'#E0E0E0',borderRadius:'1em',marginTop:'1em',justifyContent:'space-around'}}>
                       <div  style={{display:'flex', alignItems: 'center'}}>
                     <p  style={{fontWeight:'600',marginTop:'0.9em',fontFamily:'Inter-Medium',fontSize:'14px'}}> Run Emandate</p><input id="runEmandate" onChange={(e)=>handleRunEmandateBox(e.target.checked)} style={{borderRadius:'2em',marginLeft
                     :'1em',width:'1em',height:'1em'}} type="checkbox"/>
                     </div>
                     <div  style={{display:'flex', alignItems: 'center'}}>
                     <p  style={{fontWeight:'600',marginTop:'0.9em',fontFamily:'Inter-Medium',fontSize:'14px'}}> Run Emandate For Both </p><input id="runBothEmandate"  onClick={(e)=>handleRunBothEmandateBox(e.target.checked)} style={{borderRadius:'2em',marginLeft
                     :'1em',width:'1em',height:'1em'}} type="checkbox"/>
                     </div>
                       </div>
                  </div>
               
              

       <Modal isOpen={mandateCheckOpen}>
        <ModalHeader>Confirmation Message</ModalHeader>
            <ModalBody>This Action will make <u>Co Applicant</u> as the  <strong>Main Applicant</strong>
        

      
        </ModalBody>
        <ModalFooter style={{backgroundColor:'#E0E0E0',color:'black',fontWeight:'600',paddingRight:'48%'}} onClick={()=>setMandateCheckOpen(!mandateCheckOpen)}>Close</ModalFooter>
      </Modal>
       <Modal isOpen={bothMandateCheckOpen}>
        <ModalHeader>Confirmation Message</ModalHeader>
        <ModalBody>Choose whom to be the <strong>Main Applicant</strong>
        

        <div style={{display:'flex',justifyContent: 'space-around',marginBottom:'1em'}}>
          <div style={{display:'block',}}>
          <p style={{fontWeight:'600',marginTop:'1em'}}>Applicant</p><input 
          id="applicantCheck"style={{width:'3em',height:'2em'}}name="mainApplicant" type="checkbox" onClick={(e)=>handleMainApplicantSelectApplicant()}/>
          </div>
          <div style={{display:'block'}}>
          <p style={{fontWeight:'600',marginTop:'1em'}}>Co Applicant</p><input id="coapplicantCheck"name="mainApplicant" style={{width:'3em',height:'2em'}} type="checkbox" onChange={(e)=>handleMainApplicantSelectCoApplicant()}/>
          </div>
        </div>
        </ModalBody>
        <ModalFooter style={{backgroundColor:'#E0E0E0',color:'black',fontWeight:'600',paddingRight:'48%'}} onClick={()=>setBothMandateCheckOpen(!bothMandateCheckOpen)}>Close</ModalFooter>
      </Modal> 
    </div>:null}
            {status === 'Rejected' ? (
                <>
                <p style={{  marginTop: '2em',fontFamily:"Inter-Medium",fontSize:'14px',lineHeight:'10px' }}>Remarks:</p>
                  <input
                    type="text"
                    id="description"
                    placeholder="Write Description Here"
                    style={{ height: '100px', width: '1000px',borderStyle:"solid",borderWidth:"1px", borderRadius: '5px',fontFamily:"Inter-Medium",fontSize:'14px' }}

                    onChange={(e) => handleDescriptionText(e.target.value)}
                  />
                </>
              ) : (
                <></>
              )}
              
     {status === "Resend Consent to Co-Applicant" ? (
        <>
        <div  style={{ background: "#fff",border: "1px solid #ddd",borderRadius: "8px",padding: "1.5em",margin: "1em auto",width: "90%",maxWidth: "600px",boxShadow: "0 4px 10px rgba(0,0,0,0.1)",}}>
        <div style={{marginLeft:'4em'}}><img className="image" src={message} alt="message" /></div>
            <div style={{paddingLeft:'1.5em'}}>
              <p style={{}}>On Clicking <strong> Resend Consent </strong> an SMS will be sent to the <span style={{color:'black',textDecoration:"underline",paddingLeft:'5em'}}> Coapplicant registered mobile number</span>{" "}<strong>{ApplicantId?.ApplicantId?.coapplicants?.[0]?.mobile}</strong></p>
              </div>
           
              <div style={{display:'flex',alignItems:'center',justifyContent:'center',padding:'1em'}} >
              <button style={{width:"150px",backgroundColor:"#D32028",color:"white",border:"none",height:'30px',borderRadius:"5px", display: 'flex', justifyContent: 'center', alignItems: 'center' }} onClick={()=>handleResendCoApplicantConsent(ApplicantId)} type="button">Resend Consent</button>
              </div>
              </div>
            </>):(
                <></>
              )   }
             {status === 'Dropped' ? (
                <>
                <p style={{  marginTop: '2em',fontFamily:"Inter-Medium",fontSize:'14px',lineHeight:'10px' }}>Remarks:</p>
                  <input
                    type="text"
                    id="description"
                    placeholder="Write Description Here"
                    style={{ height: '100px', width: '1000px',borderStyle:"solid",borderWidth:"1px", borderRadius: '5px',fontFamily:"Inter-Medium",fontSize:'14px' }}
                    onChange={(e) => handleDescriptionText(e.target.value)}
                  />
                </>
              ) : (
                <></>
              )}
              {status === 'On Hold' ? (
                <>
                <p style={{  marginTop: '2em',fontFamily:"Inter-Medium",fontSize:'14px',lineHeight:'10px' }}>Remarks:</p>
                  <input
                    type="text"
                    id="description"
                    placeholder="Write Description Here"
                    style={{ height: '100px', width: '1000px',borderStyle:"solid",borderWidth:"1px", borderRadius: '5px',fontFamily:"Inter-Medium",fontSize:'14px' }}
                    onChange={(e) => handleDescriptionText(e.target.value)}
                  />
                </>
              ) : (
                <></>
              )}
            </FormGroup>
          </Form>
        <OtpConsent openOtpConsent={openOtpConsent} submitApplicationToInReview={submitApplicationToInReview} handleConsent={handleConsent} mobile={coAppNumber}/>       
        </ModalBody>
        { status!=="Select Status" &&
        <ModalFooter style={{display:"flex",justifyContent:"center",backgroundColor:"#E9E9E9"}}>
         {status !== "Resend Consent to Co-Applicant"? <Button style={{backgroundColor:"#D32028",color:"white",fontFamily:"Inter-Medium",fontSize:"13px",border:"solid",borderRadius:"5px",borderWidth:"1px",height:"30px"}} disabled={formLoader} onClick={() => handleStatusChange()}>
            Save and Submit
          </Button>:''}
          {alertMessage?<p style={{ backgroundColor:'#3f3623ff',padding:'5px',borderRadius:'10px',color:'red',fontWeight:'bold'}}>{alertMessage}</p>:""}
        </ModalFooter>
        }
      </Modal>

       <Modal isOpen={mandateCheckOpen}>
        <ModalHeader>Confirmation Message</ModalHeader>
            <ModalBody>This Action will make <u>Co Applicant</u> as the  <strong>Main Applicant</strong>
        

      
        </ModalBody>
        <ModalFooter style={{backgroundColor:'#E0E0E0',color:'black',fontWeight:'600',paddingRight:'48%'}} onClick={()=>setMandateCheckOpen(!mandateCheckOpen)}>Close</ModalFooter>
      </Modal>
       <Modal isOpen={bothMandateCheckOpen}>
        <ModalHeader>Confirmation Message</ModalHeader>
        <ModalBody>Choose whom to be the <strong>Main Applicant</strong>
        

        <div style={{display:'flex',justifyContent: 'space-around',marginBottom:'1em'}}>
          <div style={{display:'block',}}>
          <p style={{fontWeight:'600',marginTop:'1em'}}>Applicant</p><input 
          id="applicantCheck"style={{width:'3em',height:'2em'}}name="mainApplicant" type="checkbox" onClick={(e)=>handleMainApplicantSelectApplicant()}/>
          </div>
          <div style={{display:'block'}}>
          <p style={{fontWeight:'600',marginTop:'1em'}}>Co Applicant</p><input id="coapplicantCheck"name="mainApplicant" style={{width:'3em',height:'2em'}} type="checkbox" onChange={(e)=>handleMainApplicantSelectCoApplicant()}/>
          </div>
        </div>
        </ModalBody>
        <ModalFooter style={{backgroundColor:'#E0E0E0',color:'black',fontWeight:'600',paddingRight:'48%'}} onClick={()=>setBothMandateCheckOpen(!bothMandateCheckOpen)}>Close</ModalFooter>
      </Modal> 
    </div>
  );
}